import {api} from '@eksab/api';
import {CompetitionType} from '@eksab/features/competition/types';
import {AxiosError} from 'axios';
import {useQuery, UseQueryOptions} from '@tanstack/react-query';

type Params = {
  from?: string;
  to?: string;
  competition: number;
  competitionType: CompetitionType;
};

const queryFn = ({from, to, competition, competitionType}: Params) =>
  api
    .get<WithPagination<MatchT[]>>(`v2/matches`, {
      params: {
        from: from ? from : null,
        to: to ? to : null,
        ...(competitionType === CompetitionType.FANTASY
          ? {'for-user-created-fantasy-competitions': true}
          : {'for-user-created-competitions': true}),
        competition: competition ? competition : null,
      },
    })
    .then((res) => res.data);
const queryKey = ({from, to, competition, competitionType}: Params) => [
  'matches',
  from,
  to,
  competition,
  competitionType,
];

export function useMatchesQuery(params: Params, options?: UseQueryOptions<WithPagination<MatchT[]>, AxiosError>) {
  return useQuery<WithPagination<MatchT[]>, AxiosError>(queryKey(params), () => queryFn(params), {
    ...options,
    enabled: (!!params.from && !!params.to) || !!params.competition,
  });
}

useMatchesQuery.queryFn = queryFn;
useMatchesQuery.queryKey = queryKey;
